import { components } from "react-select";
import { User } from "react-feather";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClinicMedical } from "@fortawesome/free-solid-svg-icons";

// react-select Option for provider/practice searches: icon tile, name, optional detail and NPI.
// Expects option data of { entityType: "provider" | "practice", name, npi?, detail? } (styles in _navbar.scss)
const SearchOption = (props) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div className="navbar-search-option">
        <span className={"navbar-search-option-icon navbar-search-option-icon-" + data.entityType}>
          {data.entityType === "practice"
            ? <FontAwesomeIcon icon={faClinicMedical} />
            : <User size={15} />}
        </span>
        <div className="navbar-search-option-body">
          <div className="navbar-search-option-row">
            <span className="navbar-search-option-name" title={data.name}>{data.name}</span>
            {data.npi && <span className="navbar-search-option-npi">NPI {data.npi}</span>}
          </div>
          {data.detail && <div className="navbar-search-option-detail" title={data.detail}>{data.detail}</div>}
        </div>
      </div>
    </components.Option>
  );
};

// Keyboard shortcut badge; place inside a ".navbar-search" wrapper (hides while the search has focus)
export const SearchShortcutHint = () => (
  <kbd className="navbar-search-hint">{/Mac|iPhone|iPad/.test(navigator.platform) ? "⌘K" : "Ctrl K"}</kbd>
);

export default SearchOption;
